export default function initDropdownInputColor() {
  function adaptDropdownInputColor(input, wrapper) {
    if (input.value == "") {
      wrapper.classList.add("select-wrapper--default-value");
    } else {
      wrapper.classList.remove("select-wrapper--default-value");
    }
  }

  document.querySelectorAll(".custom-init").forEach(function (input) {
    const instance = M.FormSelect.init(input, {
      dropdownOptions: {
        onCloseStart: () => adaptDropdownInputColor(input, wrapper),
      },
    });
    const wrapper = instance.wrapper;
    adaptDropdownInputColor(input, wrapper);
  });
}
